import {
	createSlice,
	createAsyncThunk,
	createEntityAdapter,
} from "@reduxjs/toolkit";
import filter from "lodash/filter";
import { showLoader, hideLoader } from "store/misc/loaderSlice";
import { showMessage } from "store/misc/messageSlice";
import productService from "services/productService";

export const getProducts = createAsyncThunk(
	"vino/products/getProducts",
	async (arg, { dispatch, rejectWithValue }) => {
		try {
			dispatch(showLoader());
			const products = await productService.all();
			return products;
		} catch (err) {
			dispatch(
				showMessage({
					message: "Error occurred while getting products",
					variant: "error",
				})
			);
			return rejectWithValue(err.response.data);
		} finally {
			dispatch(hideLoader());
		}
	}
);

export const getProductsByCollection = createAsyncThunk(
	"vino/products/getProducts",
	async (collectionId, { dispatch, rejectWithValue }) => {
		try {
			dispatch(showLoader());
			const products = await productService.fetchByCollection(collectionId);
			return products;
		} catch (err) {
			return rejectWithValue(err.response.data);
		} finally {
			dispatch(hideLoader());
		}
	}
);

export const getVariant = createAsyncThunk(
	"vino/products/getProduct",
	async (id) => {
		const variant = await productService.getVariant(id);
		return variant;
	}
);

const productsAdapter = createEntityAdapter({
	searchText: "",
	list: [],
	variant: null,
});

export const {
	selectAll: selectProducts,
	selectById: selectProductById,
} = productsAdapter.getSelectors((state) => state.vino.products);

const productsSlice = createSlice({
	name: "vino/products",
	initialState: productsAdapter.getInitialState(),
	reducers: {
		resetProducts: (state) => {
			state.searchText = "";
			productsAdapter.removeAll(state);
			state.variant = null;
		},
		search: (state, action) => {
			state.searchText = action.payload;
			productsAdapter.setAll(
				state,
				filter(state.list, ({ name }) => {
					return name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
				})
			);
		},
	},

	extraReducers: {
		[getProducts.fulfilled]: (state, action) => {
			state.list = action.payload;
			state.searchText = "";
			productsAdapter.setAll(state, action.payload);
		},
		[getProductsByCollection.fulfilled]: (state, action) => {
			state.list = action.payload;
			state.searchText = "";
			productsAdapter.setAll(state, action.payload);
		},

		[getVariant.fulfilled]: (state, action) => {
			state.variant = action.payload;
		},
	},
});

export const { search, resetProducts } = productsSlice.actions;

export default productsSlice.reducer;
